var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clearfix" },
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-class": "inner",
              "comment-highlights": _vm.commentHighlights,
              "text-count-class": "content",
              "text-counts": _vm.textCounts,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm._t("catch"),
      _vm._v(" "),
      _vm._t("body", function () {
        return [
          _vm.value
            ? _c("p", {
                staticClass: "pega-pre-wrap",
                class: _vm.valueClass,
                attrs: { id: _vm.targetId, "data-test": "value" },
                domProps: { textContent: _vm._s(_vm.value) },
              })
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _vm._t("supplement"),
      _vm._v(" "),
      _vm._t("sub"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }